import * as React from "react";
const SvgAdd = (props) => /* @__PURE__ */ React.createElement("svg", { width: 20, height: 21, viewBox: "0 0 20 21", fill: "none", xmlns: "http://www.w3.org/2000/svg", ...props }, /* @__PURE__ */ React.createElement("path", { d: "M10 5.5L10 15.5M15 10.5L5 10.5", stroke: "white", strokeWidth: 2, strokeLinecap: "round" }));
export default SvgAdd;
